import { useTransformStringOnOffset } from '@/utils/hooks/format/useTransformString';

import type { XTagType } from '@/components/pages/content/types';

type StatusProps = {
    caption?: React.ReactNode;
    tags?: XTagType[];
    className?: string;
    'aria-label'?: string;
};

export const Status = ({ caption, tags, className, ...restProps }: StatusProps) => {
    const { OffsetReplace } = useTransformStringOnOffset();

    if (!caption) return null;

    const tagComponents = Object.fromEntries(
        (tags ?? []).map((tag, id) => [
            id,
            // eslint-disable-next-line jsx-a11y/anchor-has-content
            <a
                key={`tag-${tag.link}-${id}`}
                href={tag.link}
                className="text-icoBlue"
                target="_blank"
                rel="noopener noreferrer"
            />
        ])
    );

    return (
        <div className={className} {...restProps}>
            <OffsetReplace
                text={caption}
                components={{
                    p: <p />,
                    br: <br />,
                    ...tagComponents
                }}
            />
        </div>
    );
};
